import { Button } from './Button.js';

export interface PaginationProps {
  hasMore: boolean;
  canGoPrevious: boolean;
  onNext: () => void;
  onPrevious: () => void;
  isLoading?: boolean;
}

/**
 * Cursor-shaped, not page-numbered — matches the API's cursor pagination (`paginationQuerySchema`
 * in `@hrms/shared`'s common schemas). There is no total page count to show, only whether another
 * page exists; a caller holds its own stack of prior cursors for "Previous".
 */
export function Pagination({
  hasMore,
  canGoPrevious,
  onNext,
  onPrevious,
  isLoading = false,
}: PaginationProps) {
  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        variant="secondary"
        size="sm"
        onClick={onPrevious}
        disabled={!canGoPrevious || isLoading}
      >
        Previous
      </Button>
      <Button variant="secondary" size="sm" onClick={onNext} disabled={!hasMore || isLoading}>
        Next
      </Button>
    </div>
  );
}
